import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    postLabTestSuccess, postLabTestFailure,
    getLabTestSuccess, getLabTestFailure,
    getLabTestByIdSuccess, getLabTestByIdFailure,
    searchLabTestSuccess, searchLabTestFailure,
    putLabTestSuccess, putLabTestFailure,
    deleteLabTestSuccess, deleteLabTestFailure,
    getLabTestFormulasSuccess, getLabTestFormulasFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

function* postRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "POST",
            headers: {
                "Authorization": localStorage.getItem("item"),
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/tests`, requestDetail);
        yield put(postLabTestSuccess(response));
    } catch (error) {
        yield put(postLabTestFailure(error?.response?.message || error));
    }
}

function* getRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const { page, limit, searchQuery, departmentId } = action.payload || { page: 1, limit: null, searchQuery: "" };
        const currentBranch = yield select(state => state.branch.currentBranch);
        let url = `${process.env.REACT_APP_SERVER_API}api/laboratory/tests?page=${page}&limit=${limit}&searchQuery=${searchQuery || ""}`;
        if (departmentId) url += `&departmentId=${departmentId}`;
        const requestDetail = {
            method: "GET",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            }
        };
        const response = yield call(requestHandler, url, requestDetail);
        yield put(getLabTestSuccess(response));
    } catch (error) {
        yield put(getLabTestFailure(error?.response?.message || error));
    }
}

function* getByIdRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/tests/${action.payload}`, requestDetail);
        yield put(getLabTestByIdSuccess(response));
    } catch (error) {
        yield put(getLabTestByIdFailure(error?.response?.message || error));
    }
}

function* searchRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/tests/search/${encodeURIComponent(action.payload)}`, requestDetail);
        yield put(searchLabTestSuccess(response));
    } catch (error) {
        yield put(searchLabTestFailure(error?.response?.message || error));
    }
}

function* putRequest(action) {
    try {
        const requestDetail = {
            method: "PUT",
            headers: {
                "Authorization": localStorage.getItem("item"),
                "Content-Type": "application/json"
            },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/tests`, requestDetail);
        yield put(putLabTestSuccess(response));
    } catch (error) {
        yield put(putLabTestFailure(error?.response?.message || error));
    }
}

function* deleteRequest(action) {
    try {
        const requestDetail = {
            method: "DELETE",
            headers: {
                "Authorization": localStorage.getItem("item"),
                "Content-Type": "application/json"
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/tests/${action.payload}`, requestDetail);
        yield put(deleteLabTestSuccess(response));
    } catch (error) {
        yield put(deleteLabTestFailure(error?.response?.message || error));
    }
}

function* getFormulasRequest() {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const requestDetail = {
            method: "GET",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json"
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/tests/formulas`, requestDetail);
        yield put(getLabTestFormulasSuccess(response));
    } catch (error) {
        yield put(getLabTestFormulasFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('labTest/postLabTestRequest', postRequest);
    yield takeLatest('labTest/getLabTestRequest', getRequest);
    yield takeLatest('labTest/getLabTestByIdRequest', getByIdRequest);
    yield takeLatest('labTest/searchLabTestRequest', searchRequest);
    yield takeLatest('labTest/putLabTestRequest', putRequest);
    yield takeLatest('labTest/deleteLabTestRequest', deleteRequest);
    yield takeLatest('labTest/getLabTestFormulasRequest', getFormulasRequest);
}

export default saga;
